import React from "react";
import { GroupData, QueryStatus, SubGroupOverview } from "@shared/types";

export const SubGroupDetailsContext = React.createContext<
  | {
      groupOverview?: SubGroupOverview;
      getGroupOverviewQuery?: QueryStatus<SubGroupOverview>;
      groupId?: number;
      groupData?: GroupData;
      getGroupDataQuery?: QueryStatus<GroupData>;
    }
  | undefined
>(undefined);
